import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
var router = new Router({
  routes: [
    {
      path: "/",
      name: "index",
      component: resolve => require(["@/pages/index"], resolve),
      children: [
        {
          path: "/", //首页
          name: "home",
          component: resolve => require(["@/pages/home"], resolve)
        },
        {
          path: "/cpzx", //产品中心
          name: "cpzx",
          component: resolve => require(["@/pages/cpzx"], resolve)
        },
        {
          path: "/xwdtzx", //新闻动态中心
          name: "xwdtzx",
          component: resolve => require(["@/pages/xwdtzx"], resolve)
        },
        {
          path: "/cpxq/:moduleid/:id", //产品详情  moduleid 1产品 2企业交易记录
          name: "cpxq",
          component: resolve => require(["@/pages/cpxq"], resolve)
        },
        {
          path: "/qyjyjl", //企业交易记录
          name: "qyjyjl",
          component: resolve => require(["@/pages/qyjyjl"], resolve)
        },
        // {
        //   path: "/qyjyxq/:id", //企业交易详情
        //   name: "qyjyxq",
        //   component: resolve => require(["@/pages/qyjyxq"], resolve)
        // },
        {
          path: "/lxwm", //联系我们
          name: "lxwm",
          component: resolve => require(["@/pages/lxwm"], resolve)
        },
        {
          path: "/gywm", //关于我们
          name: "gywm",
          component: resolve => require(["@/pages/gywm"], resolve)
        }
        // {
        //   path: "/userManage/userList", //用户管理-->用户管理
        //   name: "userManageuserList",
        //   component: resolve =>
        //     require([
        //       "@/components/shichangjiaoyi/userManage/userList"
        //     ], resolve)
        // }
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    return { x: 0, y: 0 };
  }
});
// 调试时放开
// router.beforeEach((to, from, next) => {
//     let loginFlag = getCookie('loginFlag')
//     if (to.path != '/login' && loginFlag == '') {
//         router.replace({ path: '/login' });
//     } else {
//         next()
//     }
//     // next()
// });
// 调试时放开-----------end
// router.afterEach(function(transition) {
//     if (transition.path == '/') {
//         location.reload()
//             // router.replace({ name: 'login' });
//             // let menulist = store.state.menulist;
//     }
// })
router.afterEach((to, from, next) => {
  //   console.log("11");
  //   window.scrollTo(0, 0); // chrome
  document.body.scrollTop = 0; // firefox
  // document.documentElement.scrollTop = 0; // safari
  //   window.pageYOffset = 0;
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js